import { render, staticRenderFns } from "./DecisionDataRanges.vue?vue&type=template&id=3413f0c4&"
import script from "./DecisionDataRanges.vue?vue&type=script&lang=js&"
export * from "./DecisionDataRanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports